import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
// import mwstarsprnkle from "../../../../games/sparkanim"
import mwstarsprnkle from "../../games/sparkanim"
import "./CoinBurst.css";



const CoinBurst = forwardRef((props,ref)  => {
  const walletRef = useRef(null);
  const [updateWin, setUpdateWin] = useState(null);
  const [sparkleImages, setSparkleImages] = useState({});
  const sparkImagesRef = useRef({});
  let sparklemw = 1;
  let mwsparklInterval = null;


  useEffect(() =>{
    preloadSparkAnim();
  },[])

  

  const  preloadSparkAnim = () => {
     let loadedSparkImages = 0;
  
    // Preload each image
    for (let n = 1; n <= 100; n++) {
      let spark_img = new Image();
      if (loadedSparkImages !== 100) {
        let sparkImageName = `sparkanimation${n}`;
          sparkImagesRef.current[sparkImageName] = spark_img;
        spark_img.src = mwstarsprnkle[sparkImageName];
        spark_img.onload = () => {
          // setSparkleImages[sparkImageName] = spark_img;
          setSparkleImages((prevState) =>({...prevState,[sparkImageName]:spark_img}))
          loadedSparkImages++;
          if (loadedSparkImages === 100) {
            console.log('All sparkle images preloaded');
          }
        };

        spark_img.onerror = () => {
          loadedSparkImages++;
          console.warn(`Failed to load sparkle image ${sparkImageName}`);
        };
      }
    }
  }


useImperativeHandle( ref , () =>({

  showWinAnimationAndMinAmount(winAmount){
    if (document.getElementById("coinBurt_winPop")) {
      document.getElementById("coinBurt_winPop").style.display = "block";

      mwsparklInterval = setInterval(mwsparkleanimat, 35);
      setUpdateWin(winAmount);


        this.timeOut_2 = setTimeout(() => {
        if (document.getElementById("coinBurt_winPop")) {
          document.getElementById("coinBurt_winPop").style.display = "none";
        }},4000)
    }
  }
}))
  const mwsparkleanimat = () => {

    sparklemw++;
    if (sparklemw < 101) {
      const sparklemws = `sparkanimation${sparklemw}`;
      //console.log(sparklemw)
      // const starssprinklemw = mwstarsprnkle[sparklemws];
      const starssprinklemw =  sparkleImages[sparklemws]?.src;
      if (document.getElementById("coinBurt_sprkl")) {
        document.getElementById("coinBurt_sprkl").src = starssprinklemw
      }

    }
    else {
      sparklemw = 1;

      clearInterval(mwsparklInterval)
      //document.getElementById("sparkID").src = ""

    }
  }

  return (
    <div className="coinBurt_popup_back" id="coinBurt_winPop">
      <img id="coinBurt_sprkl"
        alt="coinBurt_sprkl"
        className="coinBurt_sparkAnim"
        src=""
      />
      <div className="coinBurt_winpop_amount_container">
        <span className="coinBurt_win_txt">{updateWin}</span>
      </div>
    </div>
  );
});

export default CoinBurst;
